/* External */
import axios from "axios";
import qs from "qs";

/* Other */
import { API, getURLWithParams, STATIC_URLS } from "../../utils/urls/index";
import { FORGE_ROCK_LOGIN_SCOPE, PROVIDER_FR } from "../../utils";

export const loginWithForgeRock = (username, password) => {
  // Username should always be sent in lower case to FR end-points
  const forgerockRequestParams = {
    scope: FORGE_ROCK_LOGIN_SCOPE,
    grant_type: "password",
    username: username.toLowerCase(),
    password
  };
  const basicAuthWithEncryptedString = `Basic ${window.btoa(process.env.REACT_APP_FORGE_ROCK_AUTH_STRING)}`;
  return axios.post(getURLWithParams(STATIC_URLS.FORGE_ROCK.tokenRefreshUrl), qs.stringify(forgerockRequestParams), {
    headers: {
      Authorization: basicAuthWithEncryptedString,
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
};

export const federatedLogin = (id_token, deviceId) => {
  const federatedLoginRequestParams = {
    accessToken: id_token,
    provider: PROVIDER_FR,
    deviceID: deviceId
  };
  return axios.post(getURLWithParams(API.SUBSCRIBER.federatedLogin), federatedLoginRequestParams, {
    headers: {
      "Content-Type": "application/json"
    }
  });
};

export function updateInfoUser(infoToChange) {
  return axios({
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8"
    },
    url: getURLWithParams(API.SUBSCRIBER.users),
    data: infoToChange
  });
}

/**
 * @description GET request to get user account entitlements.
 * @method getUserPreferences
 */
export function getUserPreferences() {
  return axios({
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
      Pragma: "no-cache"
    },
    url: getURLWithParams(API.SUBSCRIBER.users)
  });
}
